/** @format */
import React, { useEffect, useMemo, useState } from 'react';
import { Form, Radio, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

import Images from '../../../../../components/Commons/Images';
import translates from '../../../../../components/Commons/translates';
import { ENV_COUNTRY, ENV_IMG } from '../../../../../components/Commons/Hooks/Variables/Enviroment';

import inactiveDelivery from '../../../../../_config/v2/images/envio-inactivo.svg';
import hoverDelivery from '../../../../../_config/v2/images/envio-hover.svg';
import inactivePickUp from '../../../../../_config/v2/images/farmacia-inactivo.svg';
import hoverPickUp from '../../../../../_config/v2/images/farmacia-hover.svg';
import './style.scss';
import { GlobalConsumer } from '../../../../../components/Commons/Context/Global';
import DeliveryModal from '../../../../carts/components/BagMainInfo/components/BagButtonCalculate/components/DeliveryModal';

export default function CheckoutTypeDelivery({ item, value, onChangeType, hasCommercialOutOfStock: hasCommercialOutOfStockProp, form, isDeliveryLoading, isPickupLoading }) {
	const [deliveryForm] = Form.useForm();
	const [hoveredValue, setHoveredValue] = useState(null);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [isSelectedType, setSelectedType] = useState(null);

	// Agregamos isSelectedDeliveryType para condicionar el texto del final
	const { isCheckoutDeliveryAvailable, isCheckoutPickupAvailable, setSelectedDeliveryType, setSelectionRetirementType, isSelectionRetirementType, isSelectionRetirementError, setSelectionRetirementError } =
		GlobalConsumer();

	const hasCommercialOutOfStock = useMemo(() => {
		if (typeof hasCommercialOutOfStockProp === 'boolean') return hasCommercialOutOfStockProp;
		if (!item?.products || !Array.isArray(item.products)) return false;

		return item.products.some((p) => {
			if (p?.quotation_type === 'magistral') return false;
			return p?.stock === 0 || p?.stock_available === 0;
		});
	}, [hasCommercialOutOfStockProp, item]);

	const hideMagistralNote = ENV_COUNTRY === 'CLANICX' || ENV_COUNTRY === 'CLZUPHARMA';

	const handleShowModal = () => setIsModalVisible(true);
	const handleCancelModal = () => setIsModalVisible(false);
	const handleAcceptModal = () => setIsModalVisible(false);

	const isDeliveryDisabled =
		hasCommercialOutOfStock ||
		Object.keys(isCheckoutDeliveryAvailable).length === 0 ||
		isCheckoutDeliveryAvailable[item.name] === false ||
		isCheckoutDeliveryAvailable[item.name] === null ||
		isDeliveryLoading;

	const isPickupDisabled =
		hasCommercialOutOfStock ||
		Object.keys(isCheckoutPickupAvailable).length === 0 ||
		isCheckoutPickupAvailable[item.name] === false ||
		isCheckoutPickupAvailable[item.name] === null ||
		isPickupLoading;

	const getClassName = (radioValue) => {
		let baseClass = 'ph-bag-type-delivery-radio-button-inner-container';
		const isChecked = value === radioValue;
		const disabled = radioValue === 'domicilio' ? isDeliveryDisabled : radioValue === 'farmacia' ? isPickupDisabled : false;

		if (disabled) {
			baseClass += ' ph-bag-type-delivery-radio-button-border-disabled ph-bag-type-delivery-radio-button-inner-container-disabled';
			return baseClass;
		}

		if (hoveredValue === radioValue || isChecked) {
			baseClass += ' ph-bag-type-delivery-radio-button-border-active';
		}
		return baseClass;
	};

	useEffect(() => {
		deliveryForm.setFieldsValue({
			[`type_retirement_${item?.name}`]: value,
		});
	}, [value, item?.name, deliveryForm]);

	const handleClick = (next) => {
		if (hasCommercialOutOfStock) return;
		if (next === 'domicilio' && isDeliveryDisabled) return;
		if (next === 'farmacia' && isPickupDisabled) return;

		setSelectedDeliveryType(next === 'domicilio');
		onChangeType?.(next);
	};

	return (
		<div className="ph-checkout-type-delivery-card-main">
			<p className="ph-checkout-type-delivery-card-title">Tipo de entrega</p>

			<Form className="ph-bag-type-delivery-radio-button-form-container" form={deliveryForm}>
				<Form.Item name={`type_retirement_${item?.name}`}>
					<Radio.Group value={value} className="ph-bag-type-delivery-radio-button-container">
						<Radio
							disabled={isDeliveryDisabled}
							className={getClassName('domicilio')}
							value="domicilio"
							onClick={() => {
								handleClick('domicilio');
								setSelectedType('delivery');
								setSelectionRetirementType('delivery');
								handleShowModal();
								setSelectionRetirementError(false);
							}}
							onMouseEnter={() => !isDeliveryDisabled && setHoveredValue('domicilio')}
							onMouseLeave={() => setHoveredValue(null)}
						>
							<div className="ph-bag-type-delivery-radio-button-select-container">
								<div className="ph-bag-type-delivery-header">
									<Images
										classContent={'ph-bag-type-delivery-delivery-image-1-container'}
										classImage={'ph-bag-type-delivery-delivery-image-1'}
										webp={`${ENV_IMG}/react-type-delibery/despacho-domicilio.webp`}
										jp2={`${ENV_IMG}/react-type-delibery/despacho-domicilio.jp2`}
										jxr={`${ENV_IMG}/react-type-delibery/despacho-domicilio.jxr`}
										default={isDeliveryDisabled ? inactiveDelivery : value === 'domicilio' || hoveredValue === 'domicilio' ? hoverDelivery : inactiveDelivery}
										title={'despacho a domicilio'}
									/>
									<div className="ph-bag-type-delivery-delivery-title-container">
										<h4 className="ph-bag-type-delivery-delivery-title">
											{hideMagistralNote ? 'Envío a domicilio' : 'Envío a domicilio (1)'}
										</h4>
									</div>
								</div>

								{!hideMagistralNote && (
									<div className="ph-bag-type-delivery-description-container">
										<div className="ph-bag-type-delivery-descriptions">
											<p className="ph-bag-type-delivery-description" style={{ marginTop: '10px' }}>
												(1) Al tener al menos un producto de recetario magistral la entrega dependerá de la fecha de confección del producto (48 hs).
											</p>
										</div>
									</div>
								)}
							</div>

							{isCheckoutDeliveryAvailable[item.name] ? (
								''
							) : isCheckoutDeliveryAvailable[item.name] == null ? (
								<Spin className="ph-bag-type-delivery-radio-loading-button" indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
							) : (
								<div className="ph-bag-type-delivery-radio-no-delivery-title" />
							)}
						</Radio>

						<Radio
							disabled={isPickupDisabled}
							className={getClassName('farmacia')}
							value="farmacia"
							onClick={() => {
								handleClick('farmacia');
								setSelectedType('pharmacy');
								setSelectionRetirementType('pharmacy');
								handleShowModal();
								setSelectionRetirementError(false);
							}}
							onMouseEnter={() => !isPickupDisabled && setHoveredValue('farmacia')}
							onMouseLeave={() => setHoveredValue(null)}
						>
							<div className="ph-bag-type-delivery-radio-button-select-container">
								<div className="ph-bag-type-delivery-header">
									<Images
										classContent="ph-bag-type-delivery-delivery-image-1-container"
										classImage="ph-bag-type-delivery-delivery-image-1"
										webp={`${ENV_IMG}/react-type-delibery/retiro-farmacia.webp`}
										jp2={`${ENV_IMG}/react-type-delibery/retiro-farmacia.jp2`}
										jxr={`${ENV_IMG}/react-type-delibery/retiro-farmacia.jxr`}
										default={isPickupDisabled ? inactivePickUp : value === 'farmacia' || hoveredValue === 'farmacia' ? hoverPickUp : inactivePickUp}
										title={`retiro en ${translates.pharmacy[ENV_COUNTRY]}`}
									/>
									<div className="ph-bag-type-delivery-delivery-title-container">
										<h4 className="ph-bag-type-delivery-delivery-title">
											{hideMagistralNote ? 'Retiro en Farmacia' : 'Retiro en Farmacia (1)'}
										</h4>
									</div>
								</div>

								<div className="ph-bag-type-delivery-description-container">
									<div className="ph-bag-type-delivery-descriptions">
										<p className="ph-bag-type-delivery-description">
											{item.locals[0]?.direction + ' ' + item.locals[0]?.commune + ', ' + item.locals[0]?.city + ', Chile'}
										</p>
										{!hideMagistralNote && (
											<p className="ph-bag-type-delivery-description" style={{ marginTop: '10px' }}>
												(1) Al tener al menos un producto de recetario magistral la entrega dependerá de la fecha de confección del producto (48 hs).
											</p>
										)}
									</div>
								</div>

								{isCheckoutPickupAvailable[item.name] ? (
									''
								) : isCheckoutPickupAvailable[item.name] == null ? (
									<></>
								) : (
									<div className="ph-bag-type-delivery-radio-no-delivery-title" />
								)}
							</div>
						</Radio>
					</Radio.Group>
				</Form.Item>
			</Form>

			{isSelectionRetirementType === 'pharmacy' && (
				<div className="ph-checkout-type-delivery-card-footer">
					<p className="ph-checkout-type-delivery-card-footer-price">Costo de entrega: $0</p>
				</div>
			)}

			{isSelectionRetirementError && (
					<p className="ph-checkout-type-delivery-card-footer-advertise-validation">  Selecciona un tipo de entrega </p>
			)}

			<DeliveryModal visible={isModalVisible} onCancel={handleCancelModal} onAccept={handleAcceptModal} deliveryType={isSelectedType} />
		</div>
	);
}
